var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPengueenMobileLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321.002,
    height: 178.205,
    viewBox: "0 0 321.002 178.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11617",
    "data-name": "Gruppe 11617",
    transform: "translate(1975 -5574.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_Pengueen_Bildmarke",
    transform: "translate(-2104.4 5518.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4662",
    "data-name": "Pfad 4662",
    d: "M175.249,346v50.535a22.982,22.982,0,0,1-22.924,22.924h0A22.982,22.982,0,0,1,129.4,396.535V346",
    transform: "translate(0 -185.854)",
    fill: "#eb5c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4663",
    "data-name": "Pfad 4663",
    d: "M129.5,160.146V78.324c0-13.409,9.516-22.852,22.924-22.924h0a22.982,22.982,0,0,1,22.924,22.924v81.821",
    transform: "translate(-0.064 0)",
    fill: "#a3ccee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4664",
    "data-name": "Pfad 4664",
    d: "M251.547,86.23a17.88,17.88,0,0,0-1.658-2.739l-.108-.18c-.252-.433-.541-.829-.829-1.262l-.072-.108C238.715,66.477,225.487,55.7,202.2,55.7H151.667a21.652,21.652,0,0,0-21.591,21.591h0a21.652,21.652,0,0,0,21.591,21.591h44.623c6.524,0,11.39,1.874,14.2,4.9a16.047,16.047,0,0,0,1.37,1.73h0l.577.757c1.009,1.55,3.028,5.515,3.028,12.9,0,10.705-4.9,19.608-19.14,19.608H151.091A21.652,21.652,0,0,0,129.5,160.374h0a21.652,21.652,0,0,0,21.591,21.591h51.147c39.937,0,55.8-34.242,55.8-63.114C258,104.072,256.413,94.953,251.547,86.23Z",
    transform: "translate(-0.064 -0.192)",
    fill: "#009bd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4665",
    "data-name": "Pfad 4665",
    d: "M175.249,329.345V286.2H150.991A21.652,21.652,0,0,0,129.4,307.791h0a21.652,21.652,0,0,0,21.591,21.591h24.258Z",
    transform: "translate(0 -147.609)",
    fill: "#212654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4666",
    "data-name": "Pfad 4666",
    d: "M150.334,55.636C138.259,56.609,129.5,64.575,129.5,77.8a21.673,21.673,0,0,0,21.555,21.014h24.258V78.452A23,23,0,0,0,154.155,55.6h-3.1A4.6,4.6,0,0,1,150.334,55.636Z",
    transform: "translate(-0.064 -0.128)",
    fill: "#76b82a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPengueenMobileLight);
export default __webpack_public_path__ + "static/media/pengueen_mobile_light.55dd3b50d85af26ca87849a860b6955b.svg";
export { ForwardRef as ReactComponent };